import React from 'react';
import './StarRankingInt.css';

function StarRankingInt(props) {
	const { data, myorg } = props;
	return (
		<div className="starRankingInt">
			{data?.map((data, index) => {

				return (
					<>
						<div key={data?.rank} className={data?.rank > 9 ? 'starRankingInt__BlockNo' : 'starRankingInt__Block'} >
							<div
								className={
									myorg == data?.orgName
										? 'starRankingInt--rank'
										: 'starRankingInt--rank-case2'
								}
							>

								{data?.rankImg ? <img src={data?.rankImg} /> : data?.rank}
							</div>
							{/* <div className={data?.rank > 9 ? 'starRankingInt__BlockNewNo' : 'starRankingInt__BlockNew'} onClick={() => {
								
							}}> */}
							<div 
							className={
								!data?.myOrg
										? 'starRankingInt__BlockNew'
										: 'starRankingInt__BlockNew-case2'
								}
							// className='starRankingInt__BlockNew' onClick={() => {
								
							// }}
							>
								
							<div 
							
								className={
								myorg == data?.orgLogo
										? 'starRankingInt--institute'
										: 'starRankingInt--institute-case2'
								}
							>
							<img className='rankingimg-new' src={data?.orgLogo}/>
							</div>
							







							<div
								className={
									myorg == data?.orgName
										? 'starRankingInt--institute'
										: 'starRankingInt--institute-case2'
								}
							>
								{data?.orgName}
							</div>
							{/* <div
								className={
									myorg == data?.orgName
										? 'starRankingInt--points'
										: 'starRankingInt--points-case2'
								}
							>
								{data?.points}
							</div> */}
							</div>
						</div>
						{/* <span className="starRankingInt-line"></span> */}
					</>
				);
			})}
		</div>
	);
}

export default StarRankingInt;
